// The cookie banner on agency-built landing pages (web/templates/public/landing-page.html).
// This entry is in the `shadow-dom` rspack layer, so all the CSS it imports is injected into the
// banner's shadow root rather than the page.
import 'js/src/libs/set-webpack-nonce';
import 'css/src/global';
import 'css/src/entry-points/landing-page-cookie-banner.scss';

import { renderCookieBannerInShadowRoot } from 'js/src/components/common/cookie-policy/ShadowRootCookieBanner';
import { getLandingPageShadowRoot } from 'js/src/libs/shadow-dom/landing-page-shadow-root';

renderCookieBannerInShadowRoot(getLandingPageShadowRoot());
